import { render } from "./PaqueteProducto.vue?vue&type=template&id=0fd99c1d&scoped=true"
import script from "./PaqueteProducto.vue?vue&type=script&lang=js"
export * from "./PaqueteProducto.vue?vue&type=script&lang=js"

import "./PaqueteProducto.vue?vue&type=style&index=0&id=0fd99c1d&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd99c1d"]])

export default __exports__